import { EvaluationVehicle } from "./../../../shared/model/evaluation";
import { Observable } from "rxjs";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { ImageUploadUrlService } from "@app-services/image-upload-url.service";
import { CheckOnlineEvalDealer, CreateOnlineEvaluationRequest, CreateOnlineEvaluationResponse, OnlineEvaluationPhotoTypes } from "./online-eval.model";
import { FileUploadResult, IdName } from "@app-services/oem-dealer.service";

@Injectable({
  providedIn: "root",
})
export class OnlineEvaluationService {
  idEval: string;
  verifCode: string;

  setIdVerif(id, verifCode) {
    this.idEval = id;
    this.verifCode = verifCode;
  }

  constructor(
    private http: HttpClient,
    private imageUploadUrlService: ImageUploadUrlService,
  ) { }

  getUploadEvalImageUrl(evaluationId: string, verifCode: string): string {
    return this.imageUploadUrlService.getOnlineEvalImageUploadUrl(evaluationId, verifCode);
  }

  getUploadEvalVideoUrl(evaluationId: string, verifCode: string): string {
    return this.imageUploadUrlService.getOnlineEvalVideoUploadUrl(evaluationId, verifCode);
  }

  createOnlineEval(req: CreateOnlineEvaluationRequest): Observable<CreateOnlineEvaluationResponse> {
    return this.http.post<CreateOnlineEvaluationResponse>(`${environment.api}/onlineEvaluation/create`, req);
  }

  checkOnlineEvalDealer(evalDealerId: string): Observable<IdName> {
    return this.http.get<IdName>(`${environment.api}/onlineEvaluation/checkEvalDealer/${evalDealerId}`);
  }

  checkOnlineSeller(sellerId: string): Observable<IdName> {
    return this.http.get<IdName>(`${environment.api}/onlineEvaluation/checkSeller/${sellerId}`);
  }

  getEval(
    evaluationId: string,
    verifCode: string
  ): Observable<EvaluationVehicle> {
    return this.http.get(
      `${environment.api}/onlineEvaluation/get/${evaluationId}/${verifCode}`,
      {}
    ) as Observable<EvaluationVehicle>;
  }

  startEval(
    evaluationId: string,
    verifCode: string
  ): Observable<VehicleUpdateStatusResponse> {
    return this.http.post(
      `${environment.api}/onlineEvaluation/start/${evaluationId}/${verifCode}`,
      {}
    ) as Observable<VehicleUpdateStatusResponse>;
  }

  closeEval(
    evaluationId: string,
    verifCode: string
  ): Observable<VehicleUpdateStatusResponse> {
    return this.http.post(
      `${environment.api}/onlineEvaluation/close/${evaluationId}/${verifCode}`,
      {}
    ) as Observable<VehicleUpdateStatusResponse>;
  }

  getPhotoTypes(
    evaluationId: string,
    verifCode: string
  ): Observable<OnlineEvaluationPhotoTypes[]> {
    return this.http.get(
      `${environment.api}/onlineEvaluation/photoTypes/${evaluationId}/${verifCode}`,
      {}
    ) as Observable<OnlineEvaluationPhotoTypes[]>;
  }

  saveEval(
    evalVehicle: EvaluationVehicle,
    verifCode: string
  ): Observable<VehicleUpdateStatusResponse> {
    return this.http.post<VehicleUpdateStatusResponse>(
      `${environment.api}/onlineEvaluation/save${verifCode ? `/${verifCode}` : ''}`,
      evalVehicle
    );
  }

  uploadEvalImage(
    image: Blob,
    evaluationId: string,
    verifCode: string
  ): Observable<FileUploadResult> {
    const formData = new FormData();
    formData.append("file", image);
    return this.http.post<FileUploadResult>(
      this.getUploadEvalImageUrl(evaluationId, verifCode),
      formData
    );
  }

  uploadEvalVideo(
    video: Blob,
    evaluationId: string,
    verifCode: string
  ): Observable<FileUploadResult> {
    const formData = new FormData();
    formData.append("file", video);
    return this.http.post<FileUploadResult>(
      this.getUploadEvalVideoUrl(evaluationId, verifCode),
      formData
    );
  }

  getOptinalEquipaments(evaluationId: string, verifCode: string) {
    return this.http.get(
      `${environment.api}/onlineEvaluation/equipmentOptions/${evaluationId}/${verifCode}`,
      {}
    ) as Observable<OnlineEvalOptinalEquipament[]>;
  }
}

export class OnlineEvalOptinalEquipament {
  id?: string;
  name?: string;
  priority?: boolean;
}

export class VehicleUpdateStatusResponse {
  id?: string;
  status?: string;
  success?: boolean;
  verifCode?: string;
}
